<template>
	<div>
		<div class="supervisorRank">
			<div class="titleIcon marb25" style="height: 26px;">
				<div class="inlin">
					<i :class="`iconfont ${icon} tableIcon`"></i>
					<span class="fz16">{{title}}</span>
				</div>
			</div>
			<div class="mart25 postr">
				<template>
					<el-table class="qcTable qcHeight scrollbar" :data="newList" height="285">
						<template slot="empty">
							<div class="echartsNull">
								<div>
									<svg-icon class="fz18 marr4" icon-class='icon-default-Nodata'></svg-icon>
								</div>
								<div class="text">暂无数据</div>
							</div>
						</template>
						<el-table-column prop="Month" label="时间"></el-table-column>
						<el-table-column prop="Count" label="<60分数量"></el-table-column>
						<el-table-column prop="InPercent" label="<60分中心占比" width="140">
							<template slot-scope="scope" slot="header">
								<el-tooltip class="item" effect="dark" content="<60分中心占比 = <60分本中心报告数量/抽样数量"
									placement="bottom">
									<span>
										<60分中心占比 <i class="el-icon-info" style="color: #248AFD;"></i>
									</span>
								</el-tooltip>
							</template>
							<template slot-scope="scope">
								{{scope.row.InPercent }}
							</template>
						</el-table-column>
						<el-table-column prop="TotalPercent" label="<60分全国占比" width="140">
							<template slot-scope="scope" slot="header">
								<el-tooltip class="item" effect="dark" content="<60分全国占比 = <60分本中心报告数量/全国<60分报告数量"
									placement="bottom">
									<span>
										<60分全国占比 <i class="el-icon-info" style="color: #248AFD;"></i>
									</span>
								</el-tooltip>
							</template>
							<template slot-scope="scope">
								{{scope.row.TotalPercent }}
							</template>
						</el-table-column>
						<el-table-column prop="" label="操作">
							<template slot-scope="scope">
								<span class="tableOpe grlybtn" v-if="scope.row.Count == 0">暂无报告</span>
								<span class="tableOpe" v-else
									@click="qualifiedClick(scope.row,'unqualified')">查看报告</span>
							</template>
						</el-table-column>
					</el-table>
				</template>
				<div class="pages">
					<el-pagination class="pageAll" align="center" layout="prev, pager, next" :total="total"
						:page-size='pagesize' :current-page='currentPage' @current-change='currentChange'>
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import echarts from 'echarts'
	export default {
		props: ['list', 'Technicians', 'icon', 'title', 'type'],
		data() {
			return {
				pagesize: 6,
				total: 0,
				currentPage: 1,
				newList: []
			}
		},
		watch: {
			type(old, news) {
				if (old) {
					this.currentPage = 1;
				}
			},
			list(old, news) {
				if (old) {
					this.total = this.list.length;
					this.newList = this.list.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this
						.pagesize)
				}
			},
			currentPage(old, news) {
				if (old) {
					this.newList = this.list.slice((this.currentPage - 1) * this.pagesize, this.currentPage * this
						.pagesize)
				}
			},
		},
		computed: {
			...Vuex.mapState('supervisor', ['QualifiedPart', 'breadcrumbList', 'slider', 'GetReportListArr']),
			...Vuex.mapState('centralStatistics', ['hospitalResultParameter']),
		},
		methods: {
			...Vuex.mapMutations('breadcrumb', ['setTootipType', 'clearRow']),
			...Vuex.mapMutations('supervisor', ['currentChangesSecond', 'settableLoading', 'setLoading',
				'setBreadcrumbList'
			]),
			qualifiedClick(row, type) {
				this.setLoading(true);
				this.settableLoading(true);
				this.setTootipType(false);
				this.clearRow();
				this.currentChangesSecond(1);
				this.QualifiedPart.hospitalGuid = this.hospitalResultParameter.hospitalGuid;
				this.QualifiedPart.doctorName = '';
				this.QualifiedPart.type = type;
				this.setBreadcrumbList();
				this.GetReportListArr.type = "医生列表";
				this.GetReportListArr.name = '';
				this.breadcrumbList.push(this.formatData(row.Month) + '-' + this.formatData(row.Month));
				this.breadcrumbList.push(row.DoctorName);
				this.$router.push("/home/supervisor/qualifiedTable");
				this.breadcrumbList.push("times");
			},
			formatData(val) {
				if (val && val.toString().length > 4) {
					return val.toString().replace(/(.{4})/g, "$1/")
				}
				return val
			},
			currentChange(val) {
				this.currentPage = val;
			},
		},
	}
</script>
<style type="text/css">
	.bigScreen .supervisorPages .supervisorRank {
		padding-left: 20px;
		padding-right: 20px;
	}

	.doctorPage .pages {
		margin: 20px 0 0;
	}
</style>
